"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[422],{

/***/ 29947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ni": function() { return /* binding */ UnderlinedBoldGhostButton; },
/* harmony export */   "Sn": function() { return /* binding */ StyledButton; },
/* harmony export */   "gh": function() { return /* binding */ GhostButton; },
/* harmony export */   "hU": function() { return /* binding */ IconButton; },
/* harmony export */   "kq": function() { return /* binding */ SecondaryButton; },
/* harmony export */   "nz": function() { return /* binding */ UnderlinedGhostButton; },
/* harmony export */   "vm": function() { return /* binding */ AltButton; },
/* harmony export */   "zx": function() { return /* binding */ Button; }
/* harmony export */ });
/* unused harmony export ghostButtonMixin */
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4730);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71383);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var chime_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68526);
/* harmony import */ var _Icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92061);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);



var _excluded = ["loading", "children"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var StyledButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button */ .ZP.button(_templateObject || (_templateObject = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(["\n  display: block;\n  min-width: 80px;\n  width: 100%;\n  height: 3rem;\n  font-family: inherit;\n  font-size: 1rem;\n  font-weight: 700;\n  text-shadow: none;\n  line-height: 1.5rem;\n  border-radius: 0.75rem;\n  box-shadow: none;\n  transition: all 0.3s ease 0s;\n  padding: 0.75rem 1rem;\n  color: ", ";\n  background-color: ", ";\n  border: none;\n  cursor: pointer;\n  text-decoration: none;\n  text-align: center;\n  box-sizing: border-box;\n\n  &:focus {\n    outline: none;\n    box-shadow: 0 4px 12px rgba(51, 51, 51, 0.24);\n  }\n\n  &:active {\n    outline: none;\n    opacity: 0.6;\n  }\n\n  ", ";\n"])), chime_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .colors.notBlack */ .O9.notBlack, chime_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .colors.util.logoBrandColor */ .O9.util.logoBrandColor, function (props) {
  return (props.disabled || props.loading) && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject2 || (_templateObject2 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(["\n      opacity: 0.4;\n      pointer-events: none;\n    "])));
});
var Button = function Button(_ref) {
  var loading = _ref.loading,
      children = _ref.children,
      props = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledButton, _objectSpread(_objectSpread({
    type: 'button'
  }, props), {}, {
    children: loading ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_Icons__WEBPACK_IMPORTED_MODULE_2__/* .ButtonSpinnerIcon */ .VE, {}) : children
  }));
};
var AltButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(StyledButton)(_templateObject3 || (_templateObject3 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(["\n  background-color: ", ";\n  box-shadow: 0 4px 12px rgba(51, 51, 51, 0.16);\n"])), chime_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .colors.white */ .O9.white);
var SecondaryButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(StyledButton)(_templateObject4 || (_templateObject4 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(["\n  color: ", ";\n  background: none;\n"])), chime_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .colors.darkGreen */ .O9.darkGreen);
var ghostButtonMixin = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject5 || (_templateObject5 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(["\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit;\n"])));
var GhostButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button */ .ZP.button(_templateObject6 || (_templateObject6 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(["\n  ", "\n"])), ghostButtonMixin);
var UnderlinedGhostButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button */ .ZP.button(_templateObject7 || (_templateObject7 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(["\n  ", ";\n  text-decoration: underline;\n  font-weight: 500;\n"])), ghostButtonMixin);
var UnderlinedBoldGhostButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button */ .ZP.button(_templateObject8 || (_templateObject8 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(["\n  ", ";\n  text-decoration: underline;\n  font-weight: 700;\n"])), ghostButtonMixin);
var IconButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.attrs */ .ZP.button.attrs(function (_ref2) {
  var icon = _ref2.icon;
  return {
    children: icon || null,
    type: 'button'
  };
})(_templateObject9 || (_templateObject9 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(["\n  ", ";\n  &:disabled {\n    opacity: 0.5;\n    cursor: auto;\n  }\n  &:focus {\n    outline: 2px solid ", ";\n  }\n  &:focus:not(:focus-visible) {\n    outline: none;\n  }\n"])), ghostButtonMixin, chime_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .colors.darkGreen */ .O9.darkGreen);

/***/ }),

/***/ 92061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AC": function() { return /* binding */ BadgeDirectDepositIcon; },
/* harmony export */   "Bz": function() { return /* binding */ LightningBoltEmoji; },
/* harmony export */   "E9": function() { return /* binding */ DebitCardNumber; },
/* harmony export */   "J2": function() { return /* binding */ WhiteCloseIcon; },
/* harmony export */   "Lq": function() { return /* binding */ MicroBlinkIcon; },
/* harmony export */   "O0": function() { return /* binding */ ChimeLogo; },
/* harmony export */   "Pz": function() { return /* binding */ ErrorIcon; },
/* harmony export */   "QO": function() { return /* binding */ PayAnyonePhone; },
/* harmony export */   "TP": function() { return /* binding */ CardVendorIcon; },
/* harmony export */   "Tw": function() { return /* binding */ CloseIcon; },
/* harmony export */   "VA": function() { return /* binding */ iconsPath; },
/* harmony export */   "VE": function() { return /* binding */ ButtonSpinnerIcon; },
/* harmony export */   "ZF": function() { return /* binding */ BadgeDollarSignIcon; },
/* harmony export */   "aN": function() { return /* binding */ WarningIcon; },
/* harmony export */   "aX": function() { return /* binding */ BadgeCheckMarkIcon; },
/* harmony export */   "nG": function() { return /* binding */ BadgeNoFeesIcon; },
/* harmony export */   "pT": function() { return /* binding */ QuestionCircleIcon; },
/* harmony export */   "pi": function() { return /* binding */ BadgePayAnyoneIcon; },
/* harmony export */   "w_": function() { return /* binding */ CardBackIcon; }
/* harmony export */ });
/* unused harmony export rotate360 */
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71383);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var chime_ui_system_media__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68574);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16;




var iconsPath =  false ? 0 : '/pay/icons/'; // ============================================================================
// ANIMATIONS
// ============================================================================

var rotate360 = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)(_templateObject || (_templateObject = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  to {\n    transform: rotate(360deg);\n  }\n"]))); // ============================================================================
// GENERIC ICONS - UI and functional icons used throughout the application
// ============================================================================

var ButtonSpinnerIcon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img.attrs */ .ZP.img.attrs({
  'aria-label': 'Spinner Icon',
  src: "".concat(iconsPath, "loadingSpinner.png")
})(_templateObject2 || (_templateObject2 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  width: 1.5rem;\n  height: 1.5rem;\n  animation: ", " 1s steps(8, end) infinite;\n"])), rotate360);
var CardBackIcon = function CardBackIcon() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CardBackStyling, {
    alt: "Card Back Icon",
    src: "".concat(iconsPath, "cardBack.svg")
  });
};
var CardVendorIcon = function CardVendorIcon(_ref) {
  var icon = _ref.icon,
      vendor = _ref.vendor;
  var altText = "".concat(vendor, " Icon");
  var imgSrc = "".concat(iconsPath).concat(icon, ".svg");
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CardVendorIconStyling, {
    alt: altText,
    src: imgSrc
  });
};
var ChimeLogo = function ChimeLogo() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LogoStyling, {
    alt: "Chime Logo",
    src: "".concat(iconsPath, "headerLogo.svg")
  });
};
var CloseIcon = function CloseIcon() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CloseStyling, {
    alt: "Close Modal",
    src: "".concat(iconsPath, "close.svg")
  });
};
var DebitCardNumber = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img.attrs */ .ZP.img.attrs({
  'aria-label': 'Debit Card Number',
  src: "".concat(iconsPath, "debitCardNumber.png")
})(_templateObject3 || (_templateObject3 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  display: block;\n  max-width: 278px;\n"])));
var ErrorIcon = function ErrorIcon() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ErrorStyling, {
    alt: "Error Icon",
    src: "".concat(iconsPath, "error.svg")
  });
};
var LightningBoltEmoji = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.attrs */ .ZP.span.attrs(function () {
  return {
    role: 'img',
    'aria-label': 'Lightning Bolt Emoji',
    children: '⚡'
  };
})(_templateObject4 || (_templateObject4 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)([""])));
var MicroBlinkIcon = function MicroBlinkIcon() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
    alt: 'Powered by Microblink',
    src: "".concat(iconsPath, "microblink.svg")
  });
};
var PayAnyonePhone = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img.attrs */ .ZP.img.attrs({
  'aria-label': 'Pay Anyone Phone',
  src: "".concat(iconsPath, "app_preview_pay_anyone.svg")
})(_templateObject5 || (_templateObject5 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  display: block;\n  height: auto;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  object-fit: contain;\n"])));
var QuestionCircleIcon = function QuestionCircleIcon() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(QuestionCircleStyling, {
    alt: "Question Circle Icon",
    src: "".concat(iconsPath, "questionCircle.svg")
  });
};
var WarningIcon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.attrs */ .ZP.span.attrs(function () {
  return {
    role: 'img',
    'aria-label': 'Warning Emoji',
    children: '⚠️'
  };
})(_templateObject6 || (_templateObject6 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  margin-right: 0.5rem;\n"])));
var WhiteCloseIcon = function WhiteCloseIcon() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CloseStyling, {
    alt: "Close Modal",
    src: "".concat(iconsPath, "white-close.svg")
  });
}; // ============================================================================
// VALUE PROP ICONS - Marketing and feature highlight icons (Alphabetical)
// ============================================================================

var BadgeCheckMarkIcon = function BadgeCheckMarkIcon() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ValuePropIcon, {
    alt: "Check Mark Badge",
    src: "".concat(iconsPath, "badge.check_mark.svg")
  });
};
var BadgeDirectDepositIcon = function BadgeDirectDepositIcon() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ValuePropIcon, {
    alt: "Direct Deposit Badge",
    src: "".concat(iconsPath, "badge.direct_deposit.svg")
  });
};
var BadgeDollarSignIcon = function BadgeDollarSignIcon() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BadgeDollarSignStyling, {
    alt: "Dollar Sign Badge",
    src: "".concat(iconsPath, "badge.dollar_sign.svg")
  });
};
var BadgeNoFeesIcon = function BadgeNoFeesIcon() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ValuePropIcon, {
    alt: "No Fees Badge",
    src: "".concat(iconsPath, "badge.no_fees.svg")
  });
};
var BadgePayAnyoneIcon = function BadgePayAnyoneIcon() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ValuePropIcon, {
    alt: "Pay Anyone Badge",
    src: "".concat(iconsPath, "badge.pay_anyone.svg")
  });
}; // ============================================================================
// STYLED COMPONENTS
// ============================================================================

var ValuePropIcon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img */ .ZP.img(_templateObject7 || (_templateObject7 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  width: 100%;\n"])));
var BadgeDollarSignStyling = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img */ .ZP.img(_templateObject8 || (_templateObject8 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  width: 80px;\n"])));
var StyledIcon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img */ .ZP.img(_templateObject9 || (_templateObject9 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  display: block;\n  margin: 1.5rem auto 0.75rem;\n  width: 86px;\n  height: auto;\n"])));
var LogoStyling = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(StyledIcon)(_templateObject10 || (_templateObject10 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  margin: 0;\n"])));
var CloseStyling = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(StyledIcon)(_templateObject11 || (_templateObject11 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  margin: 0;\n  width: 24px;\n"])));
var ErrorStyling = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(StyledIcon)(_templateObject12 || (_templateObject12 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  margin: 0 0 1.5rem;\n  width: 44px;\n"])));
var QuestionCircleStyling = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(StyledIcon)(_templateObject13 || (_templateObject13 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  margin: 0;\n  width: 1rem;\n"])));
var CardBackStyling = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(StyledIcon)(_templateObject14 || (_templateObject14 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  margin: 0;\n  width: auto;\n  ", "\n"])), chime_ui_system_media__WEBPACK_IMPORTED_MODULE_0__/* ["default"].tablet */ .Z.tablet(_templateObject15 || (_templateObject15 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n    margin: 0 8.5rem;\n  "]))));
var CardVendorIconStyling = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(StyledIcon)(_templateObject16 || (_templateObject16 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  margin: 0;\n  width: 2.125rem;\n  margin-right: 0.5rem;\n"])));

/***/ }),

/***/ 50152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ Superscript; },
/* harmony export */   "Ce": function() { return /* binding */ SmallTitleSpaced; },
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "SH": function() { return /* binding */ StrongTextSpaced; },
/* harmony export */   "aF": function() { return /* binding */ StrongText; },
/* harmony export */   "al": function() { return /* binding */ TextBlock; },
/* harmony export */   "gy": function() { return /* binding */ StandardTextSpaced; },
/* harmony export */   "h7": function() { return /* binding */ SmallTitle; },
/* harmony export */   "nn": function() { return /* binding */ StandardText; },
/* harmony export */   "xv": function() { return /* binding */ Text; }
/* harmony export */ });
/* unused harmony exports CenteredSmallTitle, XLargeAmount, ItalicText, StrongTextInline, SmallText, FinePrint, InfoCall */
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71383);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);
/* harmony import */ var chime_ui_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68526);


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19;



var Paragraph = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].p */ .ZP.p(_templateObject || (_templateObject = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  padding: 0;\n  margin: 0;\n\n  a {\n    color: ", ";\n\n    &:hover,\n    &:focus {\n      outline: none;\n      font-weight: 700;\n    }\n\n    &:active,\n    &:visited {\n      color: ", ";\n    }\n  }\n"])), chime_ui_system__WEBPACK_IMPORTED_MODULE_0__/* .colors.notBlack */ .O9.notBlack, chime_ui_system__WEBPACK_IMPORTED_MODULE_0__/* .colors.notBlack */ .O9.notBlack);
var textTypes = {
  small: {
    fontSize: '12px',
    lineHeight: '17px'
  },
  standard: {
    fontSize: '16px',
    lineHeight: '24px'
  },
  large: {
    fontWeight: '700',
    fontSize: '38px',
    lineHeight: '51px'
  }
};
var Text = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .ZP.span(_templateObject2 || (_templateObject2 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  text-transform: ", ";\n\n  word-break: break-word;\n"])), function (_ref) {
  var color = _ref.color;
  return color || 'inherit';
}, function (_ref2) {
  var _textTypes$size;

  var size = _ref2.size;
  return ((_textTypes$size = textTypes[size]) === null || _textTypes$size === void 0 ? void 0 : _textTypes$size.fontSize) || 'auto';
}, function (_ref3) {
  var _textTypes$size2;

  var size = _ref3.size;
  return ((_textTypes$size2 = textTypes[size]) === null || _textTypes$size2 === void 0 ? void 0 : _textTypes$size2.lineHeight) || 'auto';
}, function (_ref4) {
  var bold = _ref4.bold;
  return bold ? 700 : 'inherit';
}, function (_ref5) {
  var capitalize = _ref5.capitalize;
  return capitalize ? 'capitalize' : '';
});
var TextBlock = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Text).attrs(function () {
  return {
    as: 'div'
  };
})(_templateObject3 || (_templateObject3 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)([""])));
var titleTypes = {
  small: {
    fontSize: '21px',
    lineHeight: '28px'
  },
  medium: {
    fontSize: '30px',
    lineHeight: '38px'
  },
  large: {
    fontSize: '38px',
    lineHeight: '48px'
  },
  xLarge: {
    fontSize: '51px',
    lineHeight: '64px'
  }
};
var Title = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject4 || (_templateObject4 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  font-weight: 700;\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n"])), function (_ref6) {
  var _titleTypes$size;

  var size = _ref6.size;
  return ((_titleTypes$size = titleTypes[size]) === null || _titleTypes$size === void 0 ? void 0 : _titleTypes$size.fontSize) || 'auto';
}, function (_ref7) {
  var _titleTypes$size2;

  var size = _ref7.size;
  return ((_titleTypes$size2 = titleTypes[size]) === null || _titleTypes$size2 === void 0 ? void 0 : _titleTypes$size2.lineHeight) || 'auto';
}, function (_ref8) {
  var color = _ref8.color;
  return color || 'inherit';
});
var CenterAligned = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Paragraph)(_templateObject5 || (_templateObject5 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  text-align: center;\n"])));
var SmallTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Paragraph).attrs({
  as: 'h1'
})(_templateObject6 || (_templateObject6 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  margin-bottom: 0.5rem;\n"])));
var SmallTitleSpaced = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(SmallTitle)(_templateObject7 || (_templateObject7 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  margin-bottom: 0.5rem;\n"])));
var CenteredSmallTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(SmallTitle)(_templateObject8 || (_templateObject8 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  text-align: center;\n"])));
var XLargeAmount = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(CenterAligned)(_templateObject9 || (_templateObject9 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  font-weight: 700;\n  font-size: 51px;\n  line-height: 64px;\n"])));
var StandardText = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Paragraph)(_templateObject10 || (_templateObject10 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  font-size: 16px;\n  line-height: 22px;\n"])));
var StandardTextSpaced = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(StandardText)(_templateObject11 || (_templateObject11 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  margin-bottom: 0.5rem;\n"])));
var ItalicText = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Text)(_templateObject12 || (_templateObject12 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  font-style: italic;\n"])));
var StrongText = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(StandardText).attrs(function (props) {
  return {
    as: props.as || 'h2'
  };
})(_templateObject13 || (_templateObject13 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  font-weight: 700;\n"])));
var StrongTextSpaced = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(StrongText)(_templateObject14 || (_templateObject14 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  margin-top: 1rem;\n  margin-bottom: 0.5rem;\n"])));
var StrongTextInline = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Text)(_templateObject15 || (_templateObject15 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  font-weight: 700;\n"])));
var SmallText = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Paragraph)(_templateObject16 || (_templateObject16 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  font-size: 12px;\n  line-height: 17px;\n  color: ", ";\n"])), function (_ref9) {
  var color = _ref9.color;
  return color ? color : chime_ui_system__WEBPACK_IMPORTED_MODULE_0__/* .colors.darkGrey */ .O9.darkGrey;
});
var FinePrint = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].small */ .ZP.small(_templateObject17 || (_templateObject17 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  font-size: 12px;\n  text-align: left;\n  line-height: 17px;\n"])));
var InfoCall = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(CenterAligned)(_templateObject18 || (_templateObject18 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  color: ", ";\n  font-size: 12px;\n  line-height: 17px;\n  text-decoration-line: underline;\n  margin: 0 auto 0.5rem;\n  background: none;\n  outline: none;\n  border: none;\n  cursor: pointer;\n  display: block;\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.darkGrey;
});
var Superscript = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].sup */ .ZP.sup(_templateObject19 || (_templateObject19 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  font-size: 12px;\n"])));

/***/ }),

/***/ 45651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export CenteredHeader */
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71383);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17674);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19521);
/* harmony import */ var chime_ui_components_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29947);
/* harmony import */ var chime_ui_components_Icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92061);
/* harmony import */ var chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50152);
/* harmony import */ var chime_ui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68526);
/* harmony import */ var chime_ui_system_media__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68574);
/* harmony import */ var hooks_useUserContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36220);
/* harmony import */ var utils_segment_trackingEvents__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64613);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);



var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;













var Header = function Header(_ref) {
  var _ref$showTagline = _ref.showTagline,
      showTagline = _ref$showTagline === void 0 ? false : _ref$showTagline,
      _ref$showLogin = _ref.showLogin,
      showLogin = _ref$showLogin === void 0 ? true : _ref$showLogin;

  var _useUserContext = (0,hooks_useUserContext__WEBPACK_IMPORTED_MODULE_6__/* .useUserContext */ .S)(),
      _useUserContext2 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_useUserContext, 1),
      userData = _useUserContext2[0];

  var loginUrl = "".concat("", "/member/sign_in?src=pav2");

  var onLoginClick = function onLoginClick() {
    (0,utils_segment_trackingEvents__WEBPACK_IMPORTED_MODULE_7__/* .trackCTATapped */ .u)('Log in', 'Landing Page', 'pay_anyone_landing_login_button', userData === null || userData === void 0 ? void 0 : userData.publicId, null);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(HeaderLayout, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(LogoAndLoginLayout, {
      showTagline: showTagline,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(chime_ui_components_Icons__WEBPACK_IMPORTED_MODULE_2__/* .ChimeLogo */ .O0, {}), showLogin && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
        size: 'medium',
        color: chime_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .colors.notBlack */ .O9.notBlack,
        bold: true,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(LogInButton, {
          as: "a",
          href: loginUrl,
          onClick: onLoginClick,
          children: "Log In"
        })
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Header);
function CenteredHeader() {
  return /*#__PURE__*/_jsx(HeaderLayout, {
    children: /*#__PURE__*/_jsx(LogoLayout, {
      children: /*#__PURE__*/_jsx(ChimeLogo, {})
    })
  });
}
var HeaderLayout = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div */ .ZP.div(_templateObject || (_templateObject = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(["\n  padding-top: 1rem;\n\n  ", "\n"])), chime_ui_system_media__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet(_templateObject2 || (_templateObject2 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(["\n    padding: 2rem 2rem 0 2rem;\n  "]))));
var LogoLayout = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div */ .ZP.div(_templateObject3 || (_templateObject3 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(["\n  display: flex;\n  justify-content: center;\n"])));
var LogoAndLoginLayout = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div */ .ZP.div(_templateObject4 || (_templateObject4 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n"])));
var LogInButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(chime_ui_components_Button__WEBPACK_IMPORTED_MODULE_1__/* .GhostButton */ .gh)(_templateObject5 || (_templateObject5 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(["\n  position: relative;\n  bottom: 0;\n  text-decoration: none;\n"])));

/***/ }),

/***/ 23991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$_": function() { return /* binding */ Footer; },
/* harmony export */   "DR": function() { return /* binding */ SpacedContent; },
/* harmony export */   "VY": function() { return /* binding */ Content; },
/* harmony export */   "mr": function() { return /* binding */ CopyrightText; },
/* harmony export */   "vs": function() { return /* binding */ ContentWrapper; }
/* harmony export */ });
/* unused harmony exports ContentLayout, PageWrapper */
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71383);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19521);
/* harmony import */ var chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50152);
/* harmony import */ var chime_ui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68526);
/* harmony import */ var chime_ui_system_media__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68574);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);



var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var Layout = function Layout(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Chime - Pay Anyone' : _ref$title,
      children = _ref.children,
      header = _ref.header,
      footer = _ref.footer;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(PageWrapper, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("title", {
        children: title
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(Card, {
      children: [header && header, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(CardContent, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(WebkitAnimationLayout, {
          children: children
        })
      })]
    }), footer ? footer : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(Footer, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(CopyrightText, {})
    })]
  });
};

var CopyrightText = function CopyrightText() {
  var date = new Date();
  var year = date.getFullYear();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
    color: chime_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .colors.darkGrey */ .O9.darkGrey,
    children: ["\xA9 2013-", year, " Chime. All rights reserved."]
  });
};
/* harmony default export */ __webpack_exports__["ZP"] = (Layout);
var ContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div */ .ZP.div(_templateObject || (_templateObject = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(["\n  position: relative;\n  ", ";\n"])), chime_ui_system_media__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet(_templateObject2 || (_templateObject2 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(["\n    margin-bottom: 4.5rem;\n  "]))));
var Footer = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].footer */ .ZP.footer(_templateObject3 || (_templateObject3 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(["\n  display: flex;\n  flex-direction: column;\n  margin-top: 5rem;\n\n  * {\n    text-align: center;\n    font-size: 9px;\n  }\n\n  ", "\n"])), chime_ui_system_media__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet(_templateObject4 || (_templateObject4 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(["\n    margin-top: 13rem;\n  "]))));
var ContentLayout = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div */ .ZP.div(_templateObject5 || (_templateObject5 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  ", "\n"])), function (_ref2) {
  var fullHeight = _ref2.fullHeight;
  return fullHeight ? chime_ui_system_media__WEBPACK_IMPORTED_MODULE_5__/* ["default"].mobileOnly */ .Z.mobileOnly(_templateObject6 || (_templateObject6 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(["\n          min-height: 75vh;\n        "]))) : '';
});
var Content = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (props, ref) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(ContentLayout, _objectSpread({
    ref: ref,
    fullHeight: true
  }, props));
});
var SpacedContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(Content)(_templateObject7 || (_templateObject7 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(["\n  justify-content: flex-start;\n  margin-top: 2rem;\n"])));
var PageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].main */ .ZP.main(_templateObject8 || (_templateObject8 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  max-width: 37.5rem;\n  margin: 0 auto;\n  padding: 0 1.5rem;\n  padding-bottom: 10vh;\n\n  ", ";\n"])), chime_ui_system_media__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet(_templateObject9 || (_templateObject9 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(["\n    padding-top: 65px;\n    padding-bottom: 50px;\n    padding-left: 0;\n    padding-right: 0;\n  "]))));
var Card = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div */ .ZP.div(_templateObject10 || (_templateObject10 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(["\n  background: ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  ", ";\n"])), function (props) {
  return props.theme.colors.white;
}, chime_ui_system_media__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet(_templateObject11 || (_templateObject11 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(["\n    min-height: 23rem;  \n    border-radius: 24px;\n    box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.08), 0 24px 32px 0 rgba(0, 0, 0, 0.04);\n    display: flex;\n    flex-direction: column;\n  "]))));
var CardContent = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div */ .ZP.div(_templateObject12 || (_templateObject12 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(["\n  ", ";\n"])), chime_ui_system_media__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet(_templateObject13 || (_templateObject13 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(["\n    padding: 0 8rem 0;\n  "])))); // Animation might cause the page to scroll
// and this fixes the scrolling issue (See: PFG-579)

var WebkitAnimationLayout = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div */ .ZP.div(_templateObject14 || (_templateObject14 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(["\n  -webkit-backface-visibility: hidden;\n  -webkit-perspective: 1000px;\n"])));

/***/ }),

/***/ 64613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yQ": function() { return /* binding */ getAnonymousId; },
  "hF": function() { return /* binding */ handleTrackingInputs; },
  "u": function() { return /* binding */ trackCTATapped; },
  "Qu": function() { return /* binding */ trackFieldFilled; },
  "TG": function() { return /* binding */ trackLandingPageViewed; },
  "vf": function() { return /* binding */ trackOcrNotTriggered; },
  "LR": function() { return /* binding */ trackOcrRecognizerError; },
  "bi": function() { return /* binding */ trackOcrTriggered; },
  "Tv": function() { return /* binding */ trackP2PEnrollEmailLinkAccessed; },
  "jE": function() { return /* binding */ trackPayAnyoneClaimInfoPageViewed; },
  "Vz": function() { return /* binding */ trackPayAnyoneConfirmationInfoPageViewed; },
  "py": function() { return /* binding */ trackPayAnyoneReceiverError; },
  "Pr": function() { return /* binding */ trackReturnUserPageViewed; },
  "BM": function() { return /* binding */ trackSuccessfulOcrScan; },
  "Ty": function() { return /* binding */ trackTermsAccepted; },
  "QZ": function() { return /* binding */ trackValuePropsViewed; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/@1debit/analytics/dist/index.mjs + 34 modules
var dist = __webpack_require__(29617);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-rum/esm/entries/main.js + 107 modules
var main = __webpack_require__(75389);
// EXTERNAL MODULE: ./node_modules/lodash/once.js
var once = __webpack_require__(51463);
var once_default = /*#__PURE__*/__webpack_require__.n(once);
// EXTERNAL MODULE: ./src/utils/analytics/eventRouter.ts
var eventRouter = __webpack_require__(12984);
;// CONCATENATED MODULE: ./src/utils/analytics/events.ts
// Page identifiers for manual page tracking via trackPage().
// Landing and return user pages match page_details oneof keys in chime-schemas.
// Claim info and confirmation pages use item_id for public_id (no page_details).
var PageEvent;

(function (PageEvent) {
  PageEvent["PAY_ANYONE_LANDING_PAGE"] = "pay_anyone_landing_page";
  PageEvent["PAY_ANYONE_RETURN_USER_PAGE"] = "pay_anyone_return_user_page";
  PageEvent["PAY_ANYONE_CLAIM_INFO_PAGE"] = "pay_anyone_claim_info_page";
  PageEvent["PAY_ANYONE_CONFIRMATION_PAGE"] = "pay_anyone_confirmation_page";
})(PageEvent || (PageEvent = {}));
;// CONCATENATED MODULE: ./src/utils/segment/trackingEvents.ts







function buildIntegrationsObject(integrationsDecisions) {
  return integrationsDecisions !== null && integrationsDecisions !== void 0 && integrationsDecisions.shouldSendToFacebook ? {} : {
    integrations: {
      'Facebook Pixel': false,
      'Facebook Conversions API': false,
      'Facebook Offline Conversions': false
    }
  };
}

function track(eventName, eventProperties) {
  var integrationsDecisions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var integrations = buildIntegrationsObject(integrationsDecisions);
  analytics.track(eventName, eventProperties, integrations);
} // Fires when a PAv2 receiver non-member visits the Landing Page (First Page) of the PAv2 Transfer


var trackLandingPageViewed = function trackLandingPageViewed(amount, publicId, senderId) {
  track('Landing Page Viewed', {
    amount: amount,
    public_id: publicId,
    sender_id: senderId
  });
  (0,eventRouter/* getAnalyticsHandler */.b)().trackPage(PageEvent.PAY_ANYONE_LANDING_PAGE, {
    page_details: (0,defineProperty/* default */.Z)({}, PageEvent.PAY_ANYONE_LANDING_PAGE, {
      amount: amount,
      sender_id: senderId
    }),
    item_id: publicId
  });
};
var trackValuePropsViewed = function trackValuePropsViewed(pageLocation, publicId, position) {
  track('Value Props Viewed', {
    public_id: publicId,
    page_location: pageLocation,
    position: position
  }); // Note: WebItemViewed.item_type is a constrained ItemType enum (not free-form),
  // so 'payanyone_public_id' cannot be set here — item_id alone carries the public_id.

  (0,eventRouter/* getAnalyticsHandler */.b)().trackEvent(dist/* Track.WebItemViewed */.fQ.WebItemViewed, {
    unique_id: 'pay_anyone_value_props_viewed',
    element_type: dist/* ElementType.ELEMENT_TYPE_SECTION */.Hd.ELEMENT_TYPE_SECTION,
    item_value: String(position).toLowerCase(),
    item_id: publicId
  });
}; // Fires when a PAv2 receiver non-member visits the Return User Page (First Page) of the PAv2 Transfer

var trackReturnUserPageViewed = function trackReturnUserPageViewed(amount, publicId, senderId) {
  track('Return User Page Viewed', {
    amount: amount,
    public_id: publicId,
    sender_id: senderId
  });
  (0,eventRouter/* getAnalyticsHandler */.b)().trackPage(PageEvent.PAY_ANYONE_RETURN_USER_PAGE, {
    page_details: (0,defineProperty/* default */.Z)({}, PageEvent.PAY_ANYONE_RETURN_USER_PAGE, {
      amount: amount,
      sender_id: senderId
    }),
    item_id: publicId
  });
}; // Fires when a PAv2 receiver non-member visits the unified Claim Info Page (Second Page) of the PAv2 Transfer

var trackPayAnyoneClaimInfoPageViewed = function trackPayAnyoneClaimInfoPageViewed(publicId) {
  trackClaimInfoPageViewed(publicId);
  (0,eventRouter/* getAnalyticsHandler */.b)().trackPage(PageEvent.PAY_ANYONE_CLAIM_INFO_PAGE, {
    item_id: publicId
  });
}; // Fires when a PAv2 receiver non-member visits the unified Claim Info Page (Second Page) of the PAv2 Transfer

var trackClaimInfoPageViewed = function trackClaimInfoPageViewed(publicId) {
  track('Pay Anyone Claim Info Page Viewed', {
    public_id: publicId
  });
}; // Fires when a PAv2 receiver non-member visits the Confirmation Page (Fourth Page) of the PAv2 Transfer


var trackPayAnyoneConfirmationInfoPageViewed = function trackPayAnyoneConfirmationInfoPageViewed(publicId) {
  track('Pay Anyone Confirmation Page Viewed', {
    public_id: publicId
  });
  (0,eventRouter/* getAnalyticsHandler */.b)().trackPage(PageEvent.PAY_ANYONE_CONFIRMATION_PAGE, {
    item_id: publicId
  });
}; // Fires whenever a receiver taps any CTA button in the Transfer flow,
// including checking boxes on 'Debit Card Info Page' for terms & conditions

var trackCTATapped = function trackCTATapped(label, // text on CTA, example: 'Instantly transfer for free', 'Next'
pageLocation, // specific page, example: 'Landing Page' , 'Personal Info Page'
uniqueId, // what the button is, example: 'pay_anyone_next_button'
publicId) {
  var claimOption = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'N/A';
  track("Pay Anyone CTA Tapped", {
    label: label,
    page_location: pageLocation,
    unique_id: uniqueId,
    public_id: publicId,
    claim_option: claimOption
  }, {
    shouldSendToFacebook: true
  }); // Note: item_type is preserved for claimOption (existing tracking) rather than
  // repurposed for 'payanyone_public_id' — item_id alone conveys the public_id link.
  // Coerce null to 'N/A' because some call sites (e.g. Header login button) pass
  // null explicitly, which bypasses the default parameter value and sends null to
  // Event Router — which is stricter than Segment about the string|undefined type.

  (0,eventRouter/* getAnalyticsHandler */.b)().trackEvent(dist/* Track.WebItemClicked */.fQ.WebItemClicked, {
    unique_id: 'pay_anyone_cta_tapped',
    element_type: dist/* ElementType.ELEMENT_TYPE_BUTTON */.Hd.ELEMENT_TYPE_BUTTON,
    label: label,
    item_type: claimOption !== null && claimOption !== void 0 ? claimOption : 'N/A',
    item_value: uniqueId,
    item_id: publicId
  });
}; // Fires whenever a PAv2 receiver types in a field and focuses out of the field to the next
// field or taps the next available CTA button in the PAv2 Transfer flow

var trackFieldFilled = function trackFieldFilled(fieldLabel, // what the field is, example: 'First name'
pageLocation, // specific page, example: 'Personal Info Page'
value, // what was typed in, example: 'Annie'
publicId) {
  track("Pay Anyone Field Filled", {
    field_label: fieldLabel,
    page_location: pageLocation,
    value: value,
    public_id: publicId
  });
  (0,eventRouter/* getAnalyticsHandler */.b)().trackEvent(dist/* Track.WebFieldFilled */.fQ.WebFieldFilled, {
    unique_id: 'pay_anyone_field_filled',
    label: fieldLabel,
    // WebFieldFilled.value is typed string in the schema; coerce so booleans
    // (e.g. "Save Debit Card" checkbox) and numbers don't fail validation.
    value: String(value),
    item_id: publicId
  });
}; // Fires whenever a PAv2 receiver submits the debit card info form successfully

var trackTermsAccepted = function trackTermsAccepted(termsValue, pageLocation, publicId) {
  track('Pay Anyone Terms Accepted', {
    terms_accepted: termsValue,
    page_location: pageLocation,
    public_id: publicId
  });
  (0,eventRouter/* getAnalyticsHandler */.b)().trackEvent(dist/* Track.WebFieldFilled */.fQ.WebFieldFilled, {
    unique_id: 'pay_anyone_terms_accepted',
    label: 'terms_accepted',
    value: String(termsValue),
    item_id: publicId
  });
}; // Fires whenever any type of error/failure occurs in the PAv2 Transfer flow

var trackPayAnyoneReceiverError = function trackPayAnyoneReceiverError(pageLocation, // specific page, example: 'Personal Info Page'
errorMessage, // what the error display to receiver is
publicId) {
  var error = new Error('Pay Anyone Receiver Error');
  track('Pay Anyone Receiver Error', {
    page_location: pageLocation,
    error_message: errorMessage,
    error_type: 'frontend',
    public_id: publicId
  });
  (0,eventRouter/* getAnalyticsHandler */.b)().trackEvent(dist/* Track.WebErrorOccurred */.fQ.WebErrorOccurred, {
    unique_id: 'pay_anyone_receiver_error',
    error_code: 'frontend',
    error_message: errorMessage,
    item_id: publicId
  });
  main/* datadogRum.addError */.v.addError(error, {
    publicId: publicId,
    errorMessage: errorMessage,
    pageLocation: pageLocation
  });
};
var handleTrackingInputs = function handleTrackingInputs(fn) {
  return once_default()(function (event, publicId) {
    if (event.type === 'blur' || event.type === 'autofill' && event.detail.autoFilled === true) {
      fn(event, publicId);
    }
  });
}; // Fire segment track event for successful OCR Scan

var trackSuccessfulOcrScan = function trackSuccessfulOcrScan(publicId, isPartialScan) {
  main/* datadogRum.addAction */.v.addAction('OCR Successful Scan', {
    publicId: publicId,
    isPartialScan: isPartialScan
  });
  track('OCR Scanned', {
    public_id: publicId,
    is_partial: isPartialScan
  });
  (0,eventRouter/* getAnalyticsHandler */.b)().trackEvent(dist/* Track.WebActionTriggered */.fQ.WebActionTriggered, {
    unique_id: 'pay_anyone_ocr_scanned',
    item_id: publicId,
    item_details: {
      pay_anyone_ocr_scanned: {
        is_partial: isPartialScan
      }
    }
  });
}; // Fire segment track event for OCR not supported

var trackOcrNotTriggered = function trackOcrNotTriggered(publicId, reason) {
  track('OCR Not Triggered', {
    public_id: publicId,
    reason: reason
  });
  (0,eventRouter/* getAnalyticsHandler */.b)().trackEvent(dist/* Track.WebActionTriggered */.fQ.WebActionTriggered, {
    unique_id: 'pay_anyone_ocr_not_triggered',
    item_id: publicId,
    item_details: {
      pay_anyone_ocr_not_triggered: {
        reason: reason
      }
    }
  });
}; // Fire segment track event for OCR triggered

var trackOcrTriggered = function trackOcrTriggered(publicId) {
  main/* datadogRum.addAction */.v.addAction('OCR Triggered', {
    publicId: publicId
  });
  track('OCR Triggered', {
    public_id: publicId
  });
  (0,eventRouter/* getAnalyticsHandler */.b)().trackEvent(dist/* Track.WebActionTriggered */.fQ.WebActionTriggered, {
    unique_id: 'pay_anyone_ocr_triggered',
    item_id: publicId
  });
}; // Fire segment track event for OCR Recognizer error

var trackOcrRecognizerError = function trackOcrRecognizerError(publicId, reason) {
  track('Recognizer Error Event', {
    public_id: publicId,
    reason: reason
  });
  (0,eventRouter/* getAnalyticsHandler */.b)().trackEvent(dist/* Track.WebErrorOccurred */.fQ.WebErrorOccurred, {
    unique_id: 'pay_anyone_ocr_recognizer_error',
    error_message: reason,
    item_id: publicId
  });
}; // Fire segment track event for P2PEnrollEmail accessed

var trackP2PEnrollEmailLinkAccessed = function trackP2PEnrollEmailLinkAccessed(publicId, receiverIdentifier) {
  track('P2P Enroll Email Link Accessed Event', {
    public_id: publicId,
    receiver_identifier: receiverIdentifier
  });
  (0,eventRouter/* getAnalyticsHandler */.b)().trackEvent(dist/* Track.WebActionTriggered */.fQ.WebActionTriggered, {
    unique_id: 'p2p_enroll_email_link_accessed',
    item_id: publicId,
    item_details: {
      p2p_enroll_email_link_accessed: {
        receiver_identifier: receiverIdentifier
      }
    }
  });
};
function getAnonymousId() {
  var analytics = globalThis.analytics;
  if (!(analytics !== null && analytics !== void 0 && analytics.user)) return undefined;

  try {
    var _analytics$user, _analytics$user$anony;

    return (_analytics$user = analytics.user()) === null || _analytics$user === void 0 ? void 0 : (_analytics$user$anony = _analytics$user.anonymousId) === null || _analytics$user$anony === void 0 ? void 0 : _analytics$user$anony.call(_analytics$user);
  } catch (_unused) {
    return undefined;
  }
}

/***/ })

}]);